
import "./CreateClient.css";
import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../../context";
import { inputType, radioType, selectType, business } from "../../interfaces";
import { savingClient, saveClientImages } from "../../api";
import { useNavigate } from "react-router-dom";
import { Value } from "react-date-picker/dist/cjs/shared/types";
import Header from "../../Components/Header/Header";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import Package from "./Package";
import PersonalData from "./PersonalData";
import PhoneNumbers from "./PhoneNumbers";
import Emails from "./Emails";
import Address from "./Address";
import BusinessTypeAndTerm from "./BusinessTypeAndTerm";
import WichNounForm from "./WichNounForm";
import Websites from "./Websites";
import LicFbInstaTkn from "./LicFbInstaTkn";
import SocialMedia from "./SocialMedia";
import HashtagCustomerNotes from "./HashtagCustomerNotes";
import LeadAndSold from "./LeadAndSold";
import CreditCard from "./CreditCard";
import AddClientImages from "./AddClientImages";
import Loading from "../../Components/Loading/Loading";

function CreateClient() {

    const {
        phoneNumberData,
        emailData,
        packageData,
        businessType,
        mortgageLogoType,
        socialMediaData,
        includeAddresses,
        whichNounForm,
        webSitesData,
        setLoading
    } = useGlobalContext()

    const navigate = useNavigate();
    const [activePackage, setActivePackage] = useState<string>("");
    const [customPackage, setCustomPackage] = useState<string>("");
    const [accountManager, setAccountManager] = useState<string>("");
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [brokerageName, setBrokerageName] = useState<string>("");
    const [clientMainName, setClientMainName] = useState<boolean>(true);
    const [companyName, setCompanyName] = useState<string>("");
    const [address, setAddress] = useState<string>("");
    const [activeIncludeAddress, setActiveIncludeAddress] = useState<boolean>(true);
    const [otherBusinessType, setOtherBusinessType] = useState<string>("");
    const [otherTerm, setOtherTerm] = useState<string>("");
    const [activeNoun, setActiveNoun] = useState<string>("");
    const [license, setLicense] = useState<string>("");
    const [facebookId, setFacebookId] = useState<string>("");
    const [instagramId, setInstagramId] = useState<string>("");
    const [accessToken, setAccessToken] = useState<string>("");
    const [hashtags, setHashtags] = useState<string>("");
    const [notes, setNotes] = useState<string>("");
    const [leadBy, setLeadBy] = useState<string>("");
    const [soldBy, setSoldBy] = useState<string>("");
    const [cardholderNameValue, setCardholderNameValue] = useState<string>("");
    const [creditCardNumbersValue, setCreditCardNumbersValue] = useState<string | undefined>("");
    const [cardDigitNumValue, setCardDigitNumValue] = useState<string>("");
    const [cardExpDateValue, setCardExpDateValue] = useState<string>("");
    const [monthlyRecurringValue, setMonthlyRecurringValue] = useState<string>("");
    const [billingAddressValue, setBillingAddressValue] = useState<string>("");
    const [signUpDateValue, setSignUpDateValue] = useState<Value | string | undefined>();
    const [billingDateValue, setBillingDateValue] = useState<string>("");
    const [billingNotesValue, setBillingNotesValue] = useState<string>("");
    const [profilePicture, setProfilePicture] = useState<File[]>([]);
    const [personalLogo, setPersonalLogo] = useState<File[]>([]);
    const [companyLogo, setCompanyLogo] = useState<File[]>([]);
    const [additionalImages, setAdditionalImages] = useState<File[]>([]);
    const [showProfilePicture, setShowProfilePicture] = useState<any[]>([]);
    const [showPersonalLogo, setShowPersonalLogo] = useState<any[]>([]);
    const [showCompanyLogo, setShowCompanyLogo] = useState<any[]>([]);
    const [showAdditionalImage, setShowAdditionalImage] = useState<any[]>([]);
    const [saveUserBtn, setSaveUserBtn] = useState(false);
    const [invalidInfoAlert, setInvalidInfoAlert] = useState(false);

    useEffect(() => {
        if (emailData[0].text) {
            window.location.reload();
        }
    }, []);

    const savingUserValidation = () => {
        if (saveUserBtn) {
            setInvalidInfoAlert(false);
            handleSavingClient().then(r => r);
        }
        else {
            setInvalidInfoAlert(true);
        }
    }

    const upDateInpuTypeData = (prevData: inputType[]): string => {
        const newData: string[] = prevData.map((data: inputType) => data.text);
        return newData.join(",");
    }

    const updateRadioTypeData = (prevData: radioType[]): string | null => {
        const newData: radioType | undefined = prevData.find((data: radioType) => data.active);
        if (newData) return newData.title;
        else return null;
    }

    const updateSelectTypeData = (prevData: selectType[]): string | null => {
        if (prevData[0].text) {
            const newData: string[] = prevData.map((data: selectType) => {
                return data.category.find((item: radioType) => item.active)?.title + "," + data.text;
            });
            return newData.join(",");
        }
        else {
            return null;
        }
    }

    const findBussinessType = (): string | undefined => {
        if (otherBusinessType) {
            return otherBusinessType;
        }
        else {
            const activeType: business | undefined = businessType.find((item:business) => item.active);
            return activeType?.title;
        }
    }

    const findBussinessTerm = (): string | undefined => {
        if (otherTerm) {
            return otherTerm;
        }
        else {
            const activeType: business | undefined = businessType.find((item:business) => item.active);
            const activeTerm = activeType?.terms.find((item:radioType) => item.active);
            return activeTerm?.title;
        }
    }

    const findBusinessCategory = (): string | undefined => {
        const activeType: business | undefined = businessType.find((item:business) => item.active);
        if (activeType?.categories) {
            return activeType.categories.filter(item => item.active)?.map(elem => elem.title).join(', ') || '';
        }
        else return '';
    }

    const findActivePackage = (): string | undefined => {
        if (customPackage) return customPackage;
        else {
            return packageData.find((data: radioType) => data.active)?.title;
        }
    }

    const findActiveLogoType = (): string => {
        const activeLogo = mortgageLogoType.find((item: radioType) => item.active);
        if (activeLogo) return activeLogo?.title;
        else return 'None';
    }

    const handleSavingClient = async () => {
        setLoading(true);
        let data: any = {
            packageName: findActivePackage(),
            accountManagerName: accountManager,
            firstName,
            lastName,
            address,
            phoneNumbers: updateSelectTypeData(phoneNumberData),
            emails: upDateInpuTypeData(emailData),
            websites: upDateInpuTypeData(webSitesData),
            clientNameMain: clientMainName,
            includeAddressOnBranding: updateRadioTypeData(includeAddresses) === "Yes",
            businessData: {
                companyName,
                brokerageName,
                businessType: findBussinessType(),
                termForBusiness: findBussinessTerm(),
                businessSubtype: findBusinessCategory(),
                mortgageLogo: findActiveLogoType(),
                noun: updateRadioTypeData(whichNounForm),
                licenseNumbers: license
            },
            additionalData: {
                socialMediaList: updateSelectTypeData(socialMediaData),
                facebookProfileId: facebookId,
                instagramProfileId: instagramId,
                accessToken,
                hashtags,
                customerInstruction: '',
                additionalNotes: notes,
                leadBy,
                soldBy
            },
            creditCard: {
                cardholderName: cardholderNameValue,
                creditCardNumbers: creditCardNumbersValue,
                cvv: cardDigitNumValue,
                expirationDate: cardExpDateValue ? cardExpDateValue : null,
                billingDate: parseInt(billingDateValue),
                signUpDate: signUpDateValue && new Date(signUpDateValue.toLocaleString('en-US', {timeZone: 'Pacific/Majuro'})),
                monthlyRecurring: monthlyRecurringValue.substring(1),
                billingNotes: billingNotesValue,
                billingAddress: billingAddressValue
            }
        }

        const getData = await savingClient(JSON.stringify(data));

        if (getData.data) {
            let formData: any = new FormData();

            profilePicture.forEach((file, index) => {
                formData.append(`profilePictures[${index}]`, file);
            });
            personalLogo.forEach((file, index) => {
                formData.append(`personalLogos[${index}]`, file);
            });
            companyLogo.forEach((file, index) => {
                formData.append(`companyLogos[${index}]`, file);
            });
            additionalImages.forEach((file, index) => {
                formData.append(`additionalImages[${index}]`, file);
            });

            formData.append("clientId", getData.data.id);
            const responseData = await saveClientImages(formData);
            if (responseData) {
                navigate("/clients");
                window.location.reload();
            }
        }
        setLoading(false);
    }

    useEffect(() => {
        if (phoneNumberData[0]?.text && emailData[0]?.text && firstName && lastName) {
            setSaveUserBtn(true);
        }
        else {
            setSaveUserBtn(false);
        }
    }, [phoneNumberData, emailData, firstName, lastName])

    return (
        <div className="CreateClient">
            <Header/>
            <div className="createClient-container">
                <div className="createClient-box">
                    <div className="createClient-header">
                        <span className="createClientLeftArrowBox">
                            <KeyboardArrowLeftIcon
                                style = {{
                                    color: "#004DE7"
                                }}
                                onClick = {() => window.history.back()}
                            />
                        </span>
                        <h2>Create A Client</h2>
                    </div>
                    <div className = "createClient-form">
                        <Package
                            activePackage = { activePackage }
                            setActivePackage = { setActivePackage }
                            customPackage = { customPackage }
                            setCustomPackage = { setCustomPackage }
                        />
                        <PersonalData
                            accountManager = { accountManager }
                            firstName = { firstName }
                            lastName = { lastName }
                            brokerageName = { brokerageName }
                            setAccountManager = { setAccountManager }
                            setFirstName = { setFirstName }
                            setLastName = { setLastName }
                            setBrokerageName = { setBrokerageName }
                            clientMainName = { clientMainName }
                            setClientMainName = { setClientMainName }
                            companyName = { companyName }
                            setCompanyName = { setCompanyName }
                            invalidInfoAlert = { invalidInfoAlert }
                        />
                        <PhoneNumbers invalidInfoAlert = { invalidInfoAlert } />
                        <Emails invalidInfoAlert = { invalidInfoAlert } />
                        <Address
                            address = { address }
                            setAddress = { setAddress }
                            activeIncludeAddress = { activeIncludeAddress }
                            setActiveIncludeAddress = { setActiveIncludeAddress }
                        />
                        <BusinessTypeAndTerm
                            otherBusinessType = { otherBusinessType }
                            setOtherBusinessType = { setOtherBusinessType }
                            otherTerm = { otherTerm }
                            setOtherTerm = { setOtherTerm }
                            setLicense = { setLicense }
                            setHashtags = { setHashtags }
                        />
                        <WichNounForm
                            activeNoun = { activeNoun }
                            setActiveNoun = { setActiveNoun }
                        />
                        <Websites/>
                        <LicFbInstaTkn
                            license = { license }
                            setLicense = { setLicense }
                            facebookId = { facebookId }
                            setFacebookId = { setFacebookId }
                            instagramId = { instagramId }
                            setInstagramId = { setInstagramId }
                            accessToken = { accessToken }
                            setAccessToken = { setAccessToken }
                        />
                        <SocialMedia/>
                        <HashtagCustomerNotes
                            hashtags = { hashtags }
                            setHashtags = { setHashtags }
                            notes = { notes }
                            setNotes = { setNotes }
                        />
                        <LeadAndSold
                            leadBy = { leadBy }
                            setLeadBy = { setLeadBy }
                            soldBy = { soldBy }
                            setSoldBy = { setSoldBy }
                        />
                        <CreditCard
                            cardholderNameValue = { cardholderNameValue }
                            setCardholderNameValue = { setCardholderNameValue }
                            creditCardNumbersValue = { creditCardNumbersValue }
                            setCreditCardNumbersValue = { setCreditCardNumbersValue }
                            cardDigitNumValue = { cardDigitNumValue }
                            setCardDigitNumValue = { setCardDigitNumValue }
                            cardExpDateValue = { cardExpDateValue }
                            setCardExpDateValue = { setCardExpDateValue }
                            monthlyRecurringValue = { monthlyRecurringValue }
                            setMonthlyRecurringValue = { setMonthlyRecurringValue }
                            billingAddressValue = { billingAddressValue }
                            setBillingAddressValue = { setBillingAddressValue }
                            signUpDateValue = { signUpDateValue }
                            setSignUpDateValue = { setSignUpDateValue }
                            billingDateValue = { billingDateValue }
                            setBillingDateValue = { setBillingDateValue }
                            billingNotesValue = { billingNotesValue }
                            setBillingNotesValue = { setBillingNotesValue }
                        />
                        <AddClientImages
                            profilePicture = { profilePicture }
                            companyLogo = { companyLogo }
                            personalLogo = { personalLogo }
                            additionalImages = { additionalImages }
                            showProfilePicture = { showProfilePicture }
                            showPersonalLogo = { showPersonalLogo }
                            showCompanyLogo = { showCompanyLogo }
                            showAdditionalImage = { showAdditionalImage }
                            setProfilePicture = { setProfilePicture }
                            setPersonalLogo = { setPersonalLogo }
                            setCompanyLogo = { setCompanyLogo }
                            setAdditionalImages = { setAdditionalImages }
                            setShowProfilePicture = { setShowProfilePicture }
                            setShowPersonalLogo = { setShowPersonalLogo }
                            setShowCompanyLogo = { setShowCompanyLogo }
                            setShowAdditionalImage = { setShowAdditionalImage }
                        />
                    </div>
                    <div className = "createClient-submit-btn">
                        <button style = {{
                            cursor: saveUserBtn ? "pointer" : "not-allowed",
                            backgroundColor: saveUserBtn ? "#004DE7" : "transparent",
                            color: !saveUserBtn ? "#004DE7" : "white",
                        }}
                            onClick = { savingUserValidation }
                        >
                            Save
                        </button>
                        <span
                            style = {{
                                display: invalidInfoAlert ? "block" : "none"
                            }}
                        >
                            Invalid Information
                        </span>
                    </div>
                </div>
            </div>
            <Loading/>
        </div>
    )
}

export default CreateClient;
